/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description geo selectors
 */

import type { State } from '@zcode/state-type'

export const selectGeo = (state: State) => state.geo
